/**
 * 判断当前是否在 App 内 WebView 打开
 * 用于 PWA 安装提示等：App 内不弹出安装提示
 * 检测：1) UA 含 com.xt.app  2) 或存在 iOS/Android WebView JSBridge
 */
export function isInApp(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator?.userAgent?.toLowerCase() || '';
  if (ua.includes('com.xt.app')) return true;
  // iOS WebView JSBridge
  if (typeof (window as any).webkit !== 'undefined' && (window as any).webkit?.messageHandlers?.xt_h5) return true;
  // Android WebView JSBridge
  if (typeof (window as any).android !== 'undefined' && typeof (window as any).android?.xt_h5 === 'function') return true;
  return false;
}
